import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { Brand } from "../../configurations";
import { ROOT } from "../../constants";
import { UserContextSelectors } from "../../redux/selectors";
import { PageContextUtils, UrlUtils } from "../../utils";

export const useSurvey = () => {
  const brandId = useSelector(UserContextSelectors.brandId);
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const isPromotionRestricted = useSelector(
    UserContextSelectors.isPromotionRestricted
  );
  const { clientPage, oldClientPage, isVisible, surveyType } =
    PageContextUtils.getSurveyData();

  const isSurveyEnabled = useMemo(() => {
    return isVisible && !!clientPage;
  }, [isVisible, clientPage]);

  const isSurveyVisible = useMemo(() => {
    if (isVisible) {
      return brandId === Brand.Sport_ES
        ? !isPromotionRestricted && isAuthenticated
        : true;
    }
    return false;
  }, [isPromotionRestricted, isAuthenticated, brandId, isVisible]);

  const findIfSurveyIsVisibleByUrl = useCallback(
    url => {
      const surveyUrls =
        (isSurveyEnabled &&
          [clientPage, oldClientPage].filter(link => !!link)) ||
        [];

      if (!Array.isArray(surveyUrls)) return false;

      const { pathname, hash } = new URL(url, window.location.origin);

      return surveyUrls?.some(surveyUrl => {
        const { pathname: surveyPathName, hash: surveyHash } = new URL(
          UrlUtils.getSEOUrlWithoutLang(surveyUrl),
          window.location.origin
        );

        const pathWithoutLang = UrlUtils.getURLWithoutLang(pathname);

        return (
          (pathWithoutLang &&
            pathWithoutLang !== ROOT &&
            pathWithoutLang === surveyPathName) ||
          (hash && hash === surveyHash)
        );
      });
    },
    [isSurveyEnabled, clientPage, oldClientPage]
  );

  const sdkUrl = useMemo(() => {
    const { sdkUrl } = PageContextUtils.getSurveyData();
    return sdkUrl;
  }, []);

  return {
    isSurveyEnabled,
    isSurveyVisible,
    surveyType,
    sdkUrl,
    findIfSurveyIsVisibleByUrl
  };
};
